import type { PersonaDto } from '@/lib/api/personas-client';
import type {
  AudienceSparkResponseDto,
  AudienceSparkSourceDto,
} from '@inference.engine/api-client/web';
import type { SocialOpportunityItem } from '@inference.engine/widgets/web';
import type { ParsedSpark } from './types';
import { i18n } from '@/shared/i18n';

type AudienceProfile = NonNullable<SocialOpportunityItem['targetAudienceProfiles']>[number];

export function mapPersonaToSpark(
  persona: PersonaDto,
  spark: AudienceSparkResponseDto,
  source: AudienceSparkSourceDto,
): ParsedSpark {
  const opportunityId = spark.sources.find((s) => s.opportunityId)?.opportunityId;

  return {
    persona: {
      assetId: persona.photoAssetId ?? undefined,
      id: persona.id,
      name:
        persona.demographicsData?.data.firstName ?? i18n.t('common:components.sidePanel.unknown'),
      age: parseInt(persona.demographicsData?.data.age ?? '0', 10),
      role:
        (persona.demographicsData?.data.profession ?? '').split('/')[0].trim() ||
        i18n.t('common:components.sidePanel.unknown'),
    },
    spark: spark.spark,
    source: source.text,
    ...(spark.sentiment && { sentiment: spark.sentiment }),
    ...(spark.personaTitle && { personaTitle: spark.personaTitle }),
    ...(opportunityId && { opportunityId }),
  };
}

export function mapAudienceProfileToSpark(profile: AudienceProfile): ParsedSpark {
  return {
    persona: {
      assetId: profile.photoAssetId ?? undefined,
      id: profile.id ?? '',
      name: profile.name,
      age: profile.age ?? 0,
      role: profile.segmentName || i18n.t('common:components.sidePanel.unknown'),
    },
    spark: profile.quote ?? '',
    source: profile.behaviors,
  };
}
